import React from 'react';
import { Table } from 'semantic-ui-react';

export default function Format({ data }) {

    const headers = data[0] && Object.keys(data[0]).map((key) => (
        <Table.HeaderCell key={key}>{key}</Table.HeaderCell>
    ));

    const formattedData = data?.map((item, index) => (
        <Table.Row key={index}>
            {Object.values(item).map((value, i) => (
                <Table.Cell key={i}>{JSON.stringify(value, null, 2)}</Table.Cell>
            ))}
        </Table.Row>
    ));

    return (
        <Table celled>
            <Table.Header>
                <Table.Row>
                    {headers}
                </Table.Row>
            </Table.Header>
            <Table.Body>
                {formattedData}
            </Table.Body>
        </Table>
    );
}
